import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const Sidebar = ({ activeItem }) => {
  const location = useLocation();

  const navItems = [
    { id: 'dashboard', label: 'PATIENT DASHBOARD', path: '/' },
    { id: 'knowledge', label: 'KNOWLEDGE EXPLORER', path: '/knowledge' },
    { id: 'documentation', label: 'DOCUMENTATION', path: '/documentation' },
    { id: 'literature', label: 'LITERATURE SENTINEL', path: '/literature' },
    { id: 'analytics', label: 'PRACTICE ANALYTICS', path: '/analytics' },
    { id: 'trials', label: 'CLINICAL TRIALS', path: '/trials' },
    { id: 'education', label: 'EDUCATION RESOURCES', path: '/education' },
    { id: 'settings', label: 'SETTINGS', path: '/settings' },
  ];

  // Determine active item from URL if not explicitly provided
  const currentPath = location.pathname;
  const currentActive = activeItem || navItems.find(item => 
    currentPath === item.path || 
    (item.id === 'dashboard' && currentPath.startsWith('/patient'))
  )?.id || 'dashboard';

  return (
    <div className="w-64 bg-gray-800 text-white h-full">
      <div className="p-5 font-bold text-gray-300">NAVIGATION</div>
      <div className="flex flex-col">
        {navItems.map(item => (
          <NavLink
            key={item.id}
            to={item.path}
            className={({ isActive }) =>
              `py-3 px-5 flex items-center ${
                isActive || currentActive === item.id
                  ? 'bg-blue-600 text-white font-bold'
                  : 'text-gray-300 hover:bg-gray-700'
              }`
            }
          >
            {(currentActive === item.id || location.pathname === item.path) && <span className="mr-2">●</span>}
            {item.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;